import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
} from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  UtilityService,
  AuthenticationService,
} from "lib/ng2-sapmp/src/providers";
import {
  ManageInventoryService,
  FanSummary,
  FansDeviceSummary,
  DevicesSummary,
  MDMDetails,
} from "./shared/";
import {
  CHART_CONFIG,
  DEVICE_DEPLOYMENT_SUMMARY,
  ERRCODES,
  APPLE_CERTIFICATE_STATUS,
} from "config";
import { BreadCrumbService } from "lib/ng2-sapmp/src/ui-components/breadcrumb";
import { PageLoaderService } from "lib/ng2-sapmp/src/ui-components/page-loader";
import { DonutChartModel } from "lib/ng2-sapmp/src/ui-components/charts/donut-chart";
import { CtnLookupModel } from "./ctnlookup-modal";
import { MobilePivotModel } from "lib/ng2-sapmp/src/ui-components/mobile-pivot";
import { MOBILEPIVOTS } from "config";
import { ConfirmModalPopupModel } from "lib/ng2-sapmp/src/ui-components/confirm-modal";
import { InitialService } from "./../initial-signup/initial-signup.service";
import { SignupService } from "../signup/shared/providers/signup.service";
import { UserProfileModel } from "lib/ng2-sapmp/src/models";
import {
  AccordionComponent,
  AccordionModel,
  AccordionListComponent,
} from "lib/ng2-sapmp/src/ui-components/accordion";
import { ImeiLookupModel } from "./imeilookup-modal/imeilookup.model";
// import { NullVisitor } from "@angular/compiler/src/render3/r3_ast";

declare var ENV_PORTAL: any;

@Component({
  selector: "app-manage-inventory",
  templateUrl: "./manage-inventory.component.html",
  styleUrls: ["./manage-inventory.component.scss"],
  providers: [ManageInventoryService, InitialService, SignupService],
  encapsulation: ViewEncapsulation.None,
})
export class ManageInventoryComponent implements OnInit {
  manageInventoryPage: any;
  fanDevicesSummary: FansDeviceSummary;
  mdmDetails: MDMDetails;
  chartLabel: string;
  donutChartData: Array<DonutChartModel>;
  chartRadius = 90;
  strokeWidth = 20;
  startIndex = 0;
  recordsPerPage = 9;
  isSearch: boolean;
  fanSearch: FormControl;
  fieldPermissions: any;
  smsSent: boolean;
  modalClass: string;
  popupModal: CtnLookupModel;
  imeipopupModal: ImeiLookupModel;
  showPopup: boolean;
  showImeiPopup: boolean;
  errorMessage: string;
  pageError: boolean;
  showError: boolean;
  chartError: boolean;
  eventEmit: any;
  pivots: Array<MobilePivotModel>;
  user: any;
  callingPage: String;
  cancelParticipationRoute: string;
  helpArticles: any;
  article: any;
  showOverviewModal: boolean;
  videoId: string;
  emmProductCode: string;
  supportArticle = false;
  options: Array<AccordionModel>;
  envPortal: string;

  public errMsgDisplay: boolean;
  public showSubHeader = true;
  private totalRecords = 0;
  private currentPage = 1;
  private fanList: any;
  private paginationArray: Array<any>;
  private devicesSummary: any;
  private readyToSetupFansCount;
  private awaitingSignupFansCount;
  private activeFansCount;
  private processingFansCount;
  private activeFans: any;
  private processingFans: any;
  private permissions: any;
  private totalFans: any;
  showReportPopup: boolean;
  overviewModalPopup: ConfirmModalPopupModel;
  private activeDeployedFans: any;
  private initialSignupStatus: any;
  public showView = false;
  public showNotEligible = false;
  public showUnknown = false;
  private ineligibleFansCount = 0;
  accountDeails: any;
  oemStatus = false;
  userModel: UserProfileModel;
  showNotificationMsg: String;
  showNewError: boolean = false;
  showNewFailureError: boolean = false;
  showchangeorgidMsg: String;
  showNeworgidFailureError: boolean = false;
  showNeworgidError: boolean = false;
  totalDevices: number = 0;

  enrollMultiplePrograms = 0;
  enrollSingleProgram = 0;

  isDisabled: boolean = true;
  welcomeFlag: boolean = false;
  checkhr: boolean = false;
  fanDetails: any;
  activeFanId: any;
  disableRemoveLink: boolean = false;
  signupInprogressFans: any;
  pendingFan: any;
  fansData: any;
  public enrollStatusSubscription: Subscription

  constructor(
    private pageloaderService: PageLoaderService,
    private breadCrumbService: BreadCrumbService,

    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private router: Router,
    private signupService: SignupService,
    private authenticationService: AuthenticationService,
    private InitialService: InitialService,
    private el: ElementRef
  ) {
    this.fanDevicesSummary = new FansDeviceSummary();
    this.mdmDetails = new MDMDetails();
    this.options = [];
    this.pageloaderService.setPageLoaderStatus(false);
    this.smsSent = sessionStorage.getItem("smsSent") ? true : false;
    this.userModel = new UserProfileModel();
    sessionStorage.removeItem("smsSent");
    const permission = sessionStorage.getItem("permissions");
    if (permission !== "null") {
      this.permissions = JSON.parse(permission);
    }
    this.envPortal = ENV_PORTAL;

    let accountSummaryData = sessionStorage.getItem('accountSummaryData') ? JSON.parse(sessionStorage.getItem('accountSummaryData')) : null;
    if(accountSummaryData && accountSummaryData.allFansInEligible) {
      this.router.navigate(['errorPage', '408']);
    }
  }

  ngOnInit() {
    let states = history.state;
    const currentUrl = this.router.url;
    if(states && states.pageUpdate){
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
    
    console.log("recieved paramters===>", states);
    this.manageInventoryService.getFanDetails().subscribe((respobj) => {
      sessionStorage.setItem(
        "fanInfoList",
        JSON.stringify(respobj.fanInfoList)
      );
      this.fansData = respobj;
      sessionStorage.setItem("accountSummaryData", JSON.stringify(respobj));
      //SAPMPDEV-218: removed other accountSummary call
      this.showHideRegisterIconLogic(respobj.noOfFans, respobj.fanInfoList);
        
      this.disableRemoveLink = respobj ? this.checkABMFEPEnding(respobj) : true;
      this.checkErrorMsg();
    });
    document.title =
      this.utilityService.getPageTitleConfig()[
      this.router.routerState.snapshot.url
      ];
    this.pivots = MOBILEPIVOTS.MANAGEINVENTORY;
    this.callingPage = sessionStorage.getItem("callingPageName");
    this.initialSignupStatus = sessionStorage.getItem("initialSignupStatus");
    sessionStorage.setItem("callingPageName", "");
    sessionStorage.removeItem("removeManage");
    if (this.callingPage === "dashboard") {
      this.breadCrumbService.setStaticBreadCrumbs("/managedashboard");
      this.breadCrumbService.setCurrentBreadCrumb({
        label: "Manage accounts",
        routerLink: "/manageInventory",
      });
    } else {
      this.breadCrumbService.setStaticBreadCrumbs("/manageInventory");
      this.breadCrumbService.setCurrentBreadCrumb({
        label: "Manage accounts",
        routerLink: "/manageInventory",
      });
    }
    sessionStorage.setItem("cancelCallingBackUrl", "/manageInventory");
    this.initPage();
    this.initFanSearch();

    const pageName = "manageInventoryPage";
    // this.helpArticles = [{ id: 1, isActive: true, category: 'Help', content: '' }];
    this.options.push({
      id: 1,
      isActive: true,
      category: "Help",
      description: "",
      ariaLabel: {
        expand: "Show help",
        collapse: "Hide help",
      },
    });
    if (!this.oemStatus) {
      this.signupService
        .requestSupportContent(
          this.utilityService.getEnvConfig().getSupportDocument + pageName
        )
        .subscribe(
          (resp) => {
            this.article = resp.supportArticles;
            this.article.name = this.article.availableArticle[0].name;
            this.supportArticle = true;
          },
          (err) => {
            // this.handleError(err);
          }
        );
    }
    this.manageInventoryService.createPageLoadProperties("MANAGE_INVENTORY");
    //show hide "Add Accounts" button based on FANs availability
    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      console.log("Enroll Status: " + status);
      this.isDisabled = !status;
      // Perform any additional actions needed when enrollStatus changes
    });
  }

  checkErrorMsg() {
    let currentDate = new Date();
    let str: string = sessionStorage?.fanInfoList;
    let arr = str && str != "undefined" ? JSON.parse(str) : [];
    let fanlistInProgress = arr.filter(
      (data) => data.accountStatus === "ACTIVE"
    );
    this.fanDetails = fanlistInProgress.map((data) => {
      var parts = data.modifiedDate
        ? data.modifiedDate.split(/[- .:]+/)
        : !data.modifiedDate && data.createdDate
          ? data.createdDate.split(/[- .:]+/)
          : null;
      var day = parseInt(parts[0]);
      var month = parts[1];
      var year = parseInt(parts[2]);
      var hour = parseInt(parts[3]);
      var minute = parseInt(parts[4]);
      var second = parseInt(parts[5]);
      // Create the date object in GMT
      var date = new Date(
        Date.UTC(year, this.getMonthIndex(month), day, hour, minute, second)
      );
      // Convert to India Standard Time
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset() + 330);
      let modifiedfanDate = date;
      const msBetweenDates = Math.abs(
        modifiedfanDate.getTime() - currentDate.getTime()
      );
      const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
      this.checkhr = hoursBetweenDates <= 24 ? true : false;
      return this.checkhr ? data.fan : null;
    });
    let onedayActiveFans = this.fanDetails.filter((data) => data != null);
    let activeFan = [...new Set(onedayActiveFans)];
    this.activeFanId = activeFan.join(", ");
    this.errMsgDisplay =
      fanlistInProgress.length >= 1 && this.activeFanId.length >= 1
        ? true
        : false;
  }


  // Helper function to convert month abbreviation to index
  getMonthIndex(month: string): number {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.findIndex((m) => m === month);
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === "url") {
      this.initPopupModal(articleNumber);
    }
  }

  initPopupModal(articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }

  handleError(error, type) {
    this.pageloaderService.setPageLoaderStatus(true);
    this.errorMessage = ERRCODES[type];
    if (type === "FETCH_PAGE") {
      this.pageError = true;
    } else {
      this.showError = true;
    }
  }

  disableNavLinks(field, fieldType) {
    field.disable = false;
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (fieldType === "button") {
      if (
        (this.readyToSetupFansCount === 0 && this.activeFansCount === 0) ||
        this.mdmDetails.productCode === null ||
        this.mdmDetails.productCode === undefined ||
        (field.fieldPermission !== "manageInventory.signup" &&
          field.fieldPermission !== "manageInventory.productselection" &&
          !this.activeDeployedFans) ||
        (field.fieldPermission === "manageInventory.signup" &&
          this.processingFansCount === this.totalFans) ||
        ((field.fieldPermission === "manageInventory.ctnLookup" ||
          field.fieldPermission === "manageInventory.imeiLookup" ||
          field.fieldPermission === "manageInventory.sendMessage") &&
          1 > JSON.parse(sessionStorage.getItem("noOfDevice"))) ||
        (field.fieldPermission === "manageInventory.productselection" &&
          this.awaitingSignupFansCount === 0 &&
          this.readyToSetupFansCount === 0) ||
        (field.fieldPermission === "manageInventory.productselection" &&
          this.fanList.awaitingSignupFanList.length - this.ineligibleFansCount <
          1 &&
          !this.fanList.newSetupFanList.length) ||
        this.utilityService.checkFieldPermission(
          field.fieldPermission,
          this.permissions.perm
        ) ||
        (1 > JSON.parse(sessionStorage.getItem("noOfDevice")) &&
          field.fieldPermission !== "manageInventory.report")
      ) {
        let showPermission = this.permissions.perm.filter((f) => {
          return ((f.action === 'show' && (f.instance === 'manageInventory.sendMessage' || f.instance === 'manageInventory.imeiLookup' || f.instance === 'manageInventory.ctnLookup')));
        });
        if ((this.activeFansCount > 0) && (showPermission.length > 0) && (JSON.parse(sessionStorage.getItem("noOfDevice")) > 0)) {
          field.disable = false;
          field.imgUrl = field.activeImgUrl;
        } else {
          field.disable = true;
          field.imgUrl = field.disabledImgUrl;
        }
      }
    } else {
      if (
        (field.fieldPermission === "manageInventory.report" && this.disableRemoveLink) ||
        this.utilityService.checkFieldPermission(
          field.fieldPermission,
          this.permissions.perm
        )
      ) {
        field.disable = true;
      }
    }
  }

  navigate(route) {
    if (route === "/ctnLookup") {
      this.eventEmit = document.activeElement;
      this.initctnLookUpPopupModal();
    } else if (route === "/imeiLookup") {
      this.eventEmit = document.activeElement;
      this.initimeiLookUpPopupModal();
    } else if (route === "/reports") {
      this.eventEmit = document.activeElement;
      this.initReportPopupModal();
    } else if (route === "/productselection" && this.welcomeFlag === true) {
      this.router.navigate(["/welcome"]);
    } else if (route === "/cancelParticipation/removeaccount") {
      // this.router.navigate([route]);
      sessionStorage.setItem("removeManage", "true");
    } else {
      this.router.navigate([route]);
    }
  }

  ngAfterViewInit() {
    this.showNotificationMsg = sessionStorage.getItem("resSuccess");
    if (this.showNotificationMsg === "true") {
      this.showNewError = true;
    } else if (this.showNotificationMsg === "false") {
      this.showNewFailureError = true;
    }
    sessionStorage.removeItem("resSuccess");

    this.showchangeorgidMsg = sessionStorage.getItem("resorgidSuccess");
    if (this.showchangeorgidMsg === "true") {
      this.showNeworgidError = true;
    } else if (this.showchangeorgidMsg === "false") {
      this.showNeworgidFailureError = true;
    }
    sessionStorage.removeItem("resorgidSuccess");
  }

  plotFanStatusChart(data) {
    let duplicateFan;
    let str: string = sessionStorage.getItem("accountSummaryData"); //sessionStorage.fanInfoList;
    let arr = str && str != "undefined" ? JSON.parse(str) : [];
    arr = arr.fanInfoList ? arr.fanInfoList : [];
    const dataArray: Array<DonutChartModel> = [];
    if (this.fanList.awaitingSignupFanList.length) {
      this.fanList.awaitingSignupFanList.filter((t) => {
        if (
          t.addpEligibleStatus === undefined ||
          t.addpEligibleStatus === false
        ) {
          this.ineligibleFansCount++;
        }
      });
    }
    this.readyToSetupFansCount = data.newSetupFanList
      ? data.newSetupFanList.length
      : 0;
    this.awaitingSignupFansCount = data.awaitingSignupFanList
      ? data.awaitingSignupFanList.length - this.ineligibleFansCount
      : 0;
    this.activeFans = arr.filter((f) => {
      return f.accountStatus === "ACTIVE";
    });
    this.signupInprogressFans = arr.filter((f) => {
      return (f.accountStatus === "PROCESSING" || f.accountStatus === "SIGNUP_INPROGRESS");
    });
    if (this.signupInprogressFans && this.signupInprogressFans.length > 0) {
      this.pendingFan = this.signupInprogressFans;
      this.processingFans = this.signupInprogressFans;
    }

    this.activeFansCount =
      (this.activeFans ? this.activeFans.length : 0) +
      this.readyToSetupFansCount;
    this.activeDeployedFans = this.activeFans.filter((f) => {
      return f.participationDate && new Date(f.participationDate) < new Date();
    }).length;

    const tempTotalFans = data.newSetupFanList.concat(this.activeFans);
    if (tempTotalFans.length === 0) {
      this.welcomeFlag = true;
    }

    //us 4460 start
    if (this.signupInprogressFans.length > 0) { this.welcomeFlag = false; }

    // end

    // for (let i = 0; i < this.activeFans.length; i++) {
    //   if (this.activeFans[i].fan !== this.pendingFan[0].fan)
    //     return flag = true;
    //   else return flag = false;
    // }

    duplicateFan = this.activeFans.filter(c => this.signupInprogressFans.map(s => s.fan).includes(c.fan))
    let activeIds = [];
    let pendingIds = [];
    const countObj = {};
    const countPendingObj = {};
    let flag: any;
    arr.map(function (item) {
      if (countObj.hasOwnProperty(item.fan)) {
        if (item.accountStatus === "ACTIVE") {
          countObj[item.fan]++;
        }
      } else {
        if (item.accountStatus === "ACTIVE") {
          countObj[item.fan] = 1;
        }
        if ((item.accountStatus === "SIGNUP_INPROGRESS" && item.emmProductCode === "DMPAABM") && duplicateFan.length < 1) {
          countPendingObj[item.fan] = 1;
        }
      }
    });

    const countArr = Object.values(countObj);
    const countPendingArr = Object.values(countPendingObj);
    let notEnrolledProgramCount = 0;
    let enrollSingleProgramCount = 0;
    let enrollMultipleProgramsCount = 0;
    let enrollSinglePendingProgramsCount = 0;
    let enrollMultiplePendingProgramsCount = 0;

    countArr.map(function (item: any) {
      if (item == 1) {
        enrollSingleProgramCount++;
      } else if (item > 1) {
        enrollMultipleProgramsCount++;
      }
    });
    countPendingArr.map(function (item: any) {
      if (item == 1) {
        enrollSinglePendingProgramsCount++;
      }
      else if (item > 1) {
        enrollMultiplePendingProgramsCount++;
      }
    });

    //notEnrolledProgram = notEnrollCount;
    this.enrollSingleProgram = enrollSingleProgramCount;
    this.enrollMultiplePrograms = enrollMultipleProgramsCount;
    let enrollPendingProgram = enrollSinglePendingProgramsCount;
    let enrollMultiPendingPrograms = enrollMultiplePendingProgramsCount
    //this.processingFans = data.revisedFanList.filter((f) => { return f.accountStatus === 'PROCESSING'; });
    // this.processingFans = JSON.parse(
    //   sessionStorage.getItem("processingFanList")
    // );
    this.processingFans = this.signupInprogressFans;
    this.processingFansCount = this.processingFans
      ? this.processingFans.length
      : 0;
    this.totalFans =
      this.awaitingSignupFansCount +
      this.activeFansCount +
      this.processingFansCount;

    if (data.newSetupFanList || data.revisedFanList) {
      sessionStorage.setItem(
        "fanLength",
        data.newSetupFanList.length + data.revisedFanList.length
      );
      if (this.readyToSetupFansCount > 0) {
        sessionStorage.setItem(
          "readyToSetupFansCount",
          this.readyToSetupFansCount
        );
      }
    }

    this.buildChartArray(
      CHART_CONFIG.NOT_ENROLLED,
      dataArray,
      this.awaitingSignupFansCount
    );


    this.buildChartArray(
      CHART_CONFIG.ENROLLED_SINGLE_PROGRAM,
      dataArray,
      this.enrollSingleProgram
    );

    this.buildChartArray(
      CHART_CONFIG.ENROLLED_MULTIPLE_PROGRAMS,
      dataArray,
      this.enrollMultiplePrograms
    );

    this.buildChartArray(
      CHART_CONFIG.PROCESSING,
      dataArray,
      enrollPendingProgram
    );
    this.buildChartArray(
      CHART_CONFIG.PROCESSING,
      dataArray,
      enrollMultiPendingPrograms
    );
    // this.buildChartArray(CHART_CONFIG.PROCESSING, dataArray, this.processingFansCount);

    this.donutChartData = dataArray;
    if (this.totalFans === 1) {
      this.chartLabel = "account";
    } else {
      this.chartLabel = "accounts";
    }
    const addpDashboardContainer =
      this.el.nativeElement.getElementsByClassName("legend-container");
    switch (this.donutChartData.length) {
      case 1: {
        addpDashboardContainer[0].style.paddingTop = "78px";
        addpDashboardContainer[0].style.paddingBottom = "25px";
        break;
      }
      case 2: {
        addpDashboardContainer[0].style.paddingTop = "58px";
        addpDashboardContainer[0].style.paddingBottom = "12px";
        break;
      }
      case 3: {
        addpDashboardContainer[0].style.paddingTop = "26px";
        addpDashboardContainer[0].style.paddingBottom = "12px";

        break;
      }
    }

    if (this.manageInventoryPage.navIcons[0].route == "/sendMessage" && this.manageInventoryPage.navIcons[2].route == "/reports") {
      let thirdPar;
      thirdPar = this.manageInventoryPage.navIcons[0];
      this.manageInventoryPage.navIcons[0] = this.manageInventoryPage.navIcons[2];
      this.manageInventoryPage.navIcons[2] = thirdPar;
    }

    this.manageInventoryPage.navIcons.forEach((element) => {
      if (element.fieldPermission != "manageInventory.report") {
        this.disableNavLinks(element, "button");
      } else {
        element.disable = false;
        if (
          (element.fieldPermission == "manageInventory.report" && this.disableRemoveLink) ||
          this.utilityService.checkFieldPermission(
            element.fieldPermission,
            this.permissions.perm
          )
        ) {
          element.disable = true;
          element.imgUrl = element.disabledImgUrl;
        }
      }
    });
    this.manageInventoryPage.navIconsOem.forEach((element) => {
      if (element.fieldPermission != "manageInventory.report") {
        this.disableNavLinks(element, "button");
      } else {
        element.disable = false;
        if (
          (element.fieldPermission == "manageInventory.report" && this.disableRemoveLink) ||
          this.utilityService.checkFieldPermission(
            element.fieldPermission,
            this.permissions.perm
          )
        ) {
          element.disable = true;
          element.imgUrl = element.disabledImgUrl;
        }
      }
    });
    this.disableNavLinks(
      this.manageInventoryPage.cancelParticipation,
      "anchor"
    );
    this.disableNavLinks(this.manageInventoryPage.report, "anchor");
    this.updateSignedUpStatus();
  }

  updateSignedUpStatus() {
    this.userModel = this.authenticationService.getUser();
    if (this.userModel && this.userModel.fanSignedUpStatus !== undefined) {
      if (
        this.awaitingSignupFansCount &&
        (this.readyToSetupFansCount || this.activeFansCount)
      ) {
        this.userModel.fanSignedUpStatus = "SOME";
      }
      if (
        this.awaitingSignupFansCount === 0 &&
        (this.readyToSetupFansCount || this.activeFansCount)
      ) {
        this.userModel.fanSignedUpStatus = "ALL";
      }
      if (
        this.awaitingSignupFansCount !== 0 &&
        this.readyToSetupFansCount < 1 &&
        this.activeFansCount < 1
      ) {
        this.userModel.fanSignedUpStatus = "NONE";
      }
      this.authenticationService.setUser(this.userModel);
    }
  }

  buildChartArray(chartConfig, dataArray, noOfFans) {
    if (noOfFans > 0) {
      const temp: DonutChartModel = {
        value: noOfFans,
        color: chartConfig.color,
        legend: noOfFans + " " + chartConfig.label,
      };
      dataArray.push(temp);
    }
  }

  buildPaginationArray(data) {
    let paginationArray = [];

    // if (this.readyToSetupFansCount > 0 && this.activeFansCount === 0 && this.processingFansCount === 0) {
    //   const temp = {
    //     fanId: null,
    //     accountStatus: 'READY_TO_SETUP'
    //   };
    //   paginationArray.push(temp);
    // }

    if (
      this.awaitingSignupFansCount > 0 &&
      this.activeFansCount === 0 &&
      this.processingFansCount === 0
    ) {
      const temp = {
        fanId: null,
        accountStatus: "AWAITING_SIGNUP",
      };
      paginationArray.push(temp);
    }

    if (this.activeFansCount > 0 || this.processingFansCount > 0) {
      paginationArray = paginationArray.concat(this.activeFans);
      paginationArray = paginationArray.concat(this.processingFans);
    }
    let arrFan = paginationArray.map((x) => (x.fanId || x.fan))
      .filter((x) => x != null);
    this.paginationArray = paginationArray.filter(function (x, index) {
      return arrFan.indexOf((x.fanId || x.fan)) === index;
    });

    // let paginationArrayAdd = [];
    // if((this.awaitingSignupFansCount > 0 && this.readyToSetupFansCount == 0 && data.revisedFanList )||
    // (this.awaitingSignupFansCount == 0 && this.readyToSetupFansCount > 0 && data.revisedFanList )){
    //   const temp = {
    //     fanId: 0,
    //     accountStatus: 'SIGNUP_SETUP_ADD'
    //   };
    // paginationArrayAdd.push(temp);
    //   this.paginationArray =  paginationArrayAdd.concat(this.paginationArray);
    // }
    // if(this.awaitingSignupFansCount > 0 && this.readyToSetupFansCount > 0 && data.revisedFanList ){
    //   const temp1 = {
    //     fanId: 0,
    //     accountStatus: 'AWAITING_SIGNUP_ADD'
    //   };
    //   paginationArrayAdd.push(temp1);
    //   const temp2 = {
    //     fanId: 0,
    //     accountStatus: 'READY_TO_SETUP_ADD'
    //   };
    //   paginationArrayAdd.push(temp2);
    //   this.paginationArray =  paginationArrayAdd.concat(this.paginationArray);
    // }
    this.totalRecords = this.paginationArray.length;
    this.searchFanDevices(null);
  }

  getPagedData() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.fanDevicesSummary = new FansDeviceSummary();
    const currentPageFans = this.paginationArray.slice(
      this.startIndex,
      this.currentPage * this.recordsPerPage
    );
    const reqFans = currentPageFans
      .filter((t) => {
        if ((t.fanId || t.fan)) {
          return t;
        }
      })
      .map((m) => {
        return (m.fanId || m.fan);
      });
    if (reqFans && reqFans.length > 0) {
      this.manageInventoryService.getDevicesSummary(reqFans).subscribe(
        (resp) => {
          if (
            resp !== undefined &&
            resp.devicesSummary !== undefined &&
            resp.devicesSummary.length > 0
          ) {
            sessionStorage.setItem(
              "devicesSummary",
              JSON.stringify(resp.devicesSummary)
            );
            let removedInActiveFanList = resp.devicesSummary.filter(x => x.fan.status !== 'INACTIVE')
            let duplicateFanId = removedInActiveFanList
              .map(v => v.fan.fanId)
              .filter((v, i, data) => data.indexOf(v) !== i)
            // let duplicateFanValues = resp.devicesSummary.filter(obj => duplicateFanId.includes(obj.fan.fanId));
            let nonDuplicateFanId = removedInActiveFanList.filter(obj => !duplicateFanId.includes(obj.fan.fanId));
            let noDuplicatefan = nonDuplicateFanId.filter(x => x.fan.emmProductCode === 'DMPAABM' && (x.fan.status === 'PROCESSING' || x.fan.status === "SIGNUP_INPROGRESS"));

            let filteredArray = resp.devicesSummary.filter(
              (x) => x.fan.status == "ACTIVE"
            );
            filteredArray = filteredArray.concat(noDuplicatefan);
            let filteredArray1 = filteredArray.map((x) => x.fan.fanId);
            let filteredArray2 = filteredArray.filter(
              (x, index) => filteredArray1.indexOf(x.fan.fanId) === index
            );
            resp.devicesSummary = filteredArray2;
          }
          if (
            sessionStorage.getItem("noOfDevice") === null ||
            JSON.parse(sessionStorage.getItem("noOfDevice")) === 0
          ) {
            let devicesCount = 0;
            if (
              resp !== undefined &&
              resp.devicesSummary !== undefined &&
              resp.devicesSummary.length > 0
            ) {
              resp.devicesSummary.filter((f) => {
                if (
                  f.deviceStatusSummary !== undefined &&
                  f.deviceStatusSummary.length > 0
                ) {
                  f.deviceStatusSummary.filter((t) => {
                    devicesCount += t.noOfDevices;
                  });
                }
              });
            }
            sessionStorage.setItem("noOfDevice", JSON.stringify(devicesCount));
            if (JSON.parse(sessionStorage.getItem("noOfDevice")) > 0) {
              this.enableSMSFunc();
            } else if (
              (sessionStorage.getItem("noOfDevice") === null ||
                JSON.parse(sessionStorage.getItem("noOfDevice")) === 0) &&
              this.totalRecords > 9
            ) {
              this.manageInventoryService
                .getFanStatusSummary()
                .subscribe((response) => {
                  this.showHideRegisterIconLogic(response.noOfFans, response.fanInfoList);
                  sessionStorage.setItem("noOfDevice", response.noOfDevices);
                  if (JSON.parse(sessionStorage.getItem("noOfDevice")) > 0) {
                    this.enableSMSFunc();
                  }
                });
            }
          }
          this.fanDevicesSummary.devicesSummary =
            this.fanDevicesSummary.devicesSummary.concat(resp.devicesSummary);
          this.pageloaderService.setPageLoaderStatus(true);
        },
        (err) => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(err, "FETCH_DEVICESUMMARY");
        }
      );
    } else {
      this.pageloaderService.setPageLoaderStatus(true);
    }
  }

  enableSMSFunc() {
    this.manageInventoryPage.navIcons.forEach((element) => {
      if (
        (element.route === "/sendMessage" || element.route === "/ctnLookup") &&
        !this.utilityService.checkFieldPermission(
          element.fieldPermission,
          this.permissions.perm
        )
      ) {
        element.disable = false;
        element.imgUrl = element.activeImgUrl;
      }
    });
    this.manageInventoryPage.navIconsOem.forEach((element) => {
      if (
        (element.route === "/sendMessage" || element.route === "/ctnLookup") &&
        !this.utilityService.checkFieldPermission(
          element.fieldPermission,
          this.permissions.perm
        )
      ) {
        element.disable = false;
        element.imgUrl = element.activeImgUrl;
      }
    });
  }

  checkForNonActiveFans() {
    // if (this.fanList.newSetupFanList && this.fanList.newSetupFanList.length > 0) {
    //   let temp = {};
    //   temp = DEVICE_DEPLOYMENT_SUMMARY.NO_SETUP;
    //   temp['deviceStatusSummary'][0].noOfDevices = this.fanList.newSetupFanList.length;
    //   this.devicesSummary.push(temp);
    // }
    if (
      this.fanList.awaitingSignupFanList &&
      this.fanList.awaitingSignupFanList.length - this.ineligibleFansCount > 0
    ) {
      let temp = {};
      temp = DEVICE_DEPLOYMENT_SUMMARY.AWAITING_SIGNUP;
      temp["deviceStatusSummary"][0].noOfDevices =
        this.fanList.awaitingSignupFanList.length - this.ineligibleFansCount;
      this.devicesSummary.push(temp);
    }
    if (this.processingFansCount >= 1) {
      for (let i = 0; i < this.processingFansCount; i++) {
        let temp = {};
        temp = DEVICE_DEPLOYMENT_SUMMARY.PROCESSING;
        temp["fan"] = [];
        temp["fan"][0] = this.processingFans[i];
        this.devicesSummary.push(temp);
      }
    }
  }

  searchFanDevices(fanId) {
    if (fanId) {
      this.pageloaderService.setPageLoaderStatus(false);
      this.manageInventoryService.getDevicesSummary([fanId]).subscribe(
        (resp) => {
          this.fanDevicesSummary.devicesSummary = resp.devicesSummary.filter(
            (item) => item.fan && item.fan.fanId === fanId
          ); // Filter in client side because of Mock data
          this.pageloaderService.setPageLoaderStatus(true);
        },
        (err) => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.totalRecords = 0;
          this.fanDevicesSummary.devicesSummary = [];
          this.handleError(err, "FETCH_DEVICESUMMARY");
          document.body.scrollTop = 0;
        }
      );
    } else {
      this.getPagedData();
    }
  }

  handleSearchClick() {
    if (this.fanSearch.value) {
      this.isSearch = true;
      this.startIndex = 0;
      this.totalRecords = 1;
      this.searchFanDevices(this.fanSearch.value);
    }
  }

  viewAllAccounts() {
    this.isSearch = false;
    this.startIndex = 0;
    this.totalRecords = this.paginationArray.length;
    this.fanSearch.setValue("");
    this.searchFanDevices(null);
  }

  onPageChange(startIndex) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.startIndex = startIndex;
    this.currentPage = startIndex / this.recordsPerPage + 1;
    this.fanDevicesSummary.currentPage =
      this.startIndex / this.fanDevicesSummary.recordsPerPage + 1;
    this.getPagedData();
  }

  initFanSearch() {
    this.fanSearch = new FormControl();
  }

  initPage() {
    this.isSearch = false;
    // this.manageInventoryService
    //   .getFanStatusSummary()
    //   .subscribe((responseObject) => {
    //     //checking if only 1 FAN and which is signed for ABM in pending
    //     // this.fansData = responseObject;
    //     // this.disableRemoveLink = responseObject ? this.checkABMFEPEnding(responseObject) : true;
    //     this.showHideRegisterIconLogic(responseObject.noOfFans, responseObject.fanInfoList);
    //     sessionStorage.setItem(
    //       "fanInfoList",
    //       JSON.stringify(responseObject.fanInfoList)
    //     );
    //   });
    this.manageInventoryPage =
      this.route.snapshot.data.pageData.manageInventory;
    if (
      this.authenticationService.getUser().fanSignedUpStatus !== "NotEligible"
    ) {
      this.showView = true;
      this.initChart();
    } else {
      if (
        this.authenticationService.getUser().fanSignedUpStatus === "NotEligible"
      ) {
        this.showNotEligible = true;
      }
      // else if(this.authenticationService.getUser().fanSignedUpStatus === 'Unknown'){
      //   this.showUnknown = true;
      // }
      this.pageloaderService.setPageLoaderStatus(true);
    }
    // }, (err) => {
    //   this.handleError(err, 'FETCH_PAGE');
    // });
  }

  showHideRegisterIconLogic(noOfFans, fanInfoList){
    this.authenticationService.updateEnrollStatus({noOfFans: noOfFans, fanInfoList: fanInfoList});
  }

  checkABMFEPEnding(obj: any) {
    // if(obj?.fansSummary && obj?.fansSummary.length > 0){
    //   //check Processing, Active and awaiting_setup fanlist for disable change for ABM FE pending
    //   if((obj?.fansSummary.length == 1 && obj?.fansSummary[0].status == "PROCESSING") || (obj?.fansSummary.length == 1 && obj?.fansSummary[0].status == "READY_TO_SETUP") || (obj?.fansSummary.length == 1 && obj?.fansSummary[0].status == "AWAITING_SIGNUP")){
    //     return true;
    //   }else {
    //     let data = obj?.fansSummary.map((elm) => elm.status);
    //     if ((data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("AWAITING_SIGNUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("ACTIVE") != -1)){
    //         return false;
    //     }else if((data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1) || (data.indexOf("READY_TO_SETUP") != -1 && data.indexOf("AWAITING_SIGNUP") != -1)) {
    //         return true;
    //     }else {
    //         return false;
    //     }
    //   }

    // }
    if (obj !== null || obj !== undefined || obj) {
      if (obj?.fanInfoList && obj?.fanInfoList.length > 0) {
        //check status ACTIVE, INACTIVE, SIGNUP_INPROGRESS
        let data = new Set(obj?.fanInfoList.map((elm) => elm.accountStatus));

        if ((data.has("ACTIVE") && data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE")) || (data.has("ACTIVE") && data.has("SIGNUP_INPROGRESS")) || (data.has("ACTIVE") && data.has("INACTIVE"))) {
          return false;
        } else if ((data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE")) || (data.size == 1 && data.has("SIGNUP_INPROGRESS")) || (data.size == 1 && data.has("INACTIVE"))) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  initChart() {
    this.manageInventoryService.getFANList().subscribe(
      (resp) => {
        this.fanList = resp;
        sessionStorage.setItem('summaryData', JSON.stringify(resp));

        let awaitFansArr = this.fanList.awaitingSignupFanList.filter(
          (x) => x.addpEligibleStatus === true
        );
        let moreCheckFlag = true;
        if (awaitFansArr && awaitFansArr.length > 0) {
          this.isDisabled = false;
          moreCheckFlag = false;
        } else {
          moreCheckFlag = true;
        }

        let fanInfoList;
        if (sessionStorage.getItem("fanInfoList") !== "undefined") {
          fanInfoList = JSON.parse(sessionStorage.getItem("fanInfoList"));
          if (fanInfoList && moreCheckFlag) {
            let fanArr = fanInfoList.map((x) => x.fan);
            let fanArrRefine = fanArr.filter(
              (x, index) => fanArr.indexOf(x) === index
            );

            let activeFanArr = fanInfoList.filter(
              (x) => x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS"
            );

            if (activeFanArr.length === fanArrRefine.length * 2) {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }
          }
        }
        this.chartError = false;
        if (resp.productCode !== null && resp.productCode !== undefined) {
          this.mdmDetails.productCode = resp.productCode;
          this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
          if (this.mdmDetails.productCode === "ADDPMDM") {
            this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
            let productDetails = {
              emmProductCode: "",
              selectedAccID: "",
              signupEmmStatus: "",
            };
            productDetails.emmProductCode = "ADDPMDM";
            productDetails.selectedAccID = resp.ibmEmmAccountId;
            productDetails.signupEmmStatus = "revised";
            sessionStorage.setItem(
              "manage-product",
              JSON.stringify(productDetails)
            );
          } else {
            this.oemStatus = true;
            if (
              resp.googleEmmAccountId !== null &&
              resp.googleEmmAccountId !== undefined
            ) {
              this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
            }
            if (
              resp.samsungEmmAccountId !== null &&
              resp.samsungEmmAccountId !== undefined
            ) {
              this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
            }
            if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
              sessionStorage.setItem(
                "fanInfoList",
                JSON.stringify(resp.fanInfoList)
              );
            }

            if (this.fanList.awaitingSignupFanList.length > 0) {
              let signupFanList = [];
              for (
                let i = 0;
                i < this.fanList.awaitingSignupFanList.length;
                i++
              ) {
                signupFanList.push(this.fanList.awaitingSignupFanList[i].fanId);
              }
              sessionStorage.setItem(
                "signupFanList",
                JSON.stringify(signupFanList)
              );
            }
          }
          sessionStorage.setItem("mdmDetails", JSON.stringify(this.mdmDetails));
        }
        this.plotFanStatusChart(this.fanList);
        this.buildPaginationArray(this.fanList);
        if (
          (this.initialSignupStatus === "Completed" &&
            this.mdmDetails !== null &&
            this.mdmDetails.productCode === "ADDPMDM") ||
          (this.readyToSetupFansCount > 0 &&
            this.mdmDetails !== null &&
            this.mdmDetails.productCode === "ADDPMDM") ||
          (this.activeFansCount > 0 &&
            this.mdmDetails.productCode === "ADDPMDM" &&
            this.fanList !== 0)
        ) {
          this.getAppleCertificateStatus();
        }
      },
      (err) => {
        this.handleError(err, "FETCH_FANSUMMARY");
        this.chartError = true;
        this.buildErrorChartData();
      }
    );
  }

  buildErrorChartData() {
    this.donutChartData = [];
    this.chartLabel = "accounts";
    const temp = {
      value: 0,
      color: "#ccc",
      legend: "Error",
    };
    this.donutChartData.push(temp);
  }

  getAppleCertificateStatus() {
    this.manageInventoryService.getAppleSummary().subscribe(
      (respobj2) => {
        this.manageInventoryPage.appleCertificate.label =
          APPLE_CERTIFICATE_STATUS[respobj2.status];
      },
      (error) => this.handleError(error, "FETCH_APPLECERT_STATUS")
    );
  }

  dismissInfo() {
    this.smsSent = false;
    this.showNewError = false;
    this.showNeworgidError = false;
  }

  dismissError() {
    this.showError = false;
  }

  initctnLookUpPopupModal() {
    this.popupModal = new CtnLookupModel();
    this.modalClass = "modal-lg";
    this.showPopup = true;
  }

  initimeiLookUpPopupModal() {
    this.imeipopupModal = new ImeiLookupModel();
    this.modalClass = "modal-lg";
    this.showImeiPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  closeImeiPopup() {
    this.showImeiPopup = false;
  }

  initReportPopupModal() {
    this.modalClass = "modal-lg";
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.showReportPopup = true;

    this.manageInventoryService.createPageLoadProperties(
      "REQUEST_REPORTS_MODAL"
    );
  }
  closeReportPopup() {
    this.showReportPopup = false;

    this.manageInventoryService.createPageLoadProperties("MANAGE_INVENTORY");
  }
}
